// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"28f7feee","97":"43668d48","851":"11808440"}[chunkId] + ".chunk.css";
};